var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSyncGoogleDrive = function SvgSyncGoogleDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 18L17 50h18l17-32H35.5z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 18L35 50h18l17-32H52z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18L53 50h34L70 18z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50l18 32h18L35 50H17z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 50l18 32h18L53 50H35z",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50l18 32h18L71 50H53z",
    fill: "#EA4335"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 50h18l18 32H53L35 50z",
    fill: "#188038"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50h34L71 82H53V50z",
    fill: "#1967D2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 78,
    r: 20,
    fill: "#1a1a2e",
    stroke: "#4285F4",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v10l7 7",
    stroke: "#4285F4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78c0-5.523 4.477-10 10-10M88 78c0 5.523-4.477 10-10 10",
    stroke: "#4285F4",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
};

export default SvgSyncGoogleDrive;